import React from "react"
import CV from "../../assets/luis_1.3.pdf"
import {FiDownload} from "react-icons/fi"


const CTA = () => {
    return(
        <div className="cta">
            <a href="#contact" className="btn btn-primary">Get in touch</a>
            <a href={CV} download className="btn"><FiDownload/> Download CV</a>
        </div>
    )
}

export default CTA
